<template>
  <div class="homepage-container">
    <!-- 顶部导航栏 -->
    <header class="navbar">
      <div class="nav-container">
        <div class="nav-left">
          <div class="logo">
            <img src="@/assets/logo.png" alt="视频回调信息解析" class="logo-img" />
            <span class="logo-text">视频回调信息解析</span>
          </div>
          <nav class="nav-menu">
            <a href="#" class="nav-item active">首页</a>
            <a href="#" class="nav-item">定价</a>
            <a href="#" class="nav-item">接口文档</a>
            <a href="#" class="nav-item">关于我们</a>
          </nav>
        </div>
        <div class="nav-right">
          <el-button type="primary" @click="showLoginDialog" class="login-btn">登录</el-button>
          <el-button @click="showRegisterDialog" class="register-btn">注册</el-button>
        </div>
      </div>
    </header>

    <!-- 主内容区域 -->
    <main class="main-content">
      <!-- 英雄区域 -->
      <section class="hero-section">
        <div class="hero-container">
          <div class="hero-content">
            <h1 class="hero-title">视频解析与水印识别一体化平台</h1>
            <p class="hero-subtitle">
              智能解析视频内容，自动判断是否带水印，并实时采集点赞、分享、关注等核心互动数据。
            </p>
            <div class="hero-buttons">
              <el-button type="primary" size="large" @click="showRegisterDialog" class="cta-button">
                立即开始使用
              </el-button>
              <el-button size="large" @click="scrollToFeatures" class="secondary-button">
                了解更多
              </el-button>
            </div>
          </div>
          <div class="hero-image">
            <div class="dashboard-preview">
              <div class="dashboard-header">
                <div class="dashboard-dots">
                  <span class="dot red"></span>
                  <span class="dot yellow"></span>
                  <span class="dot green"></span>
                </div>
                <div class="dashboard-title">视频解析数据总览</div>
              </div>
              <div class="dashboard-content">
                <div class="json-preview">
                  <div class="json-title">JSON 解析成功</div>
                  <pre class="json-block">{
  "list": [
    {
      "id": 2004,
      "input_url": "https://v.douyin.com/xt4cMMvRLdE/",
      "create_time": 1768190611,
      "author": "心太懒",
      "avatar": "https://p3-pc...jpeg",
      "follower": "1",
      "total_favorited": "145",
      "title": "谁懂啊！韩综修罗场里的吃嘴子操作太绝了...",
      "digg": 137,
      "comment": 0,
      "collect": 10,
      "share_count": 92,
      "cover": "https://p3-pc..."
    }
  ]
}</pre>
                </div>
                <div class="stats-container">
                  <div class="stat-item" v-for="stat in stats" :key="stat.label">
                    <div class="stat-value">{{ stat.value }}</div>
                    <div class="stat-label">{{ stat.label }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 特性区域 -->
      <section class="features-section" ref="featuresSection">
        <div class="section-container">
          <h2 class="section-title">核心能力</h2>
          <p class="section-subtitle">覆盖水印检测与互动数据全链路解析</p>
          <div class="features-grid">
            <div class="feature-card" v-for="feature in features" :key="feature.title">
              <div class="feature-icon" :style="{ backgroundColor: feature.color }">
                <el-icon :size="32">
                  <component :is="feature.icon" />
                </el-icon>
              </div>
              <h3 class="feature-title">{{ feature.title }}</h3>
              <p class="feature-description">{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 定价区域 -->
      <section class="pricing-section">
        <div class="section-container">
          <h2 class="section-title">灵活定价方案</h2>
          <p class="section-subtitle">为不同规模的视频业务提供精细化配置</p>
          <div class="pricing-grid">
            <!-- 基础版套餐 -->
            <div class="pricing-card" v-for="plan in pricingPlans" :key="plan.name">
              <div class="pricing-header">
                <h3 class="plan-name">{{ plan.name }}</h3>
                <div class="plan-price">
                  <span class="price">¥{{ plan.price }}</span>
                  <span class="period">/次</span>
                </div>
                <p class="plan-description">{{ plan.description }}</p>
              </div>
              <div class="plan-features">
                <!-- 套餐特性列表 -->
                <div class="feature-item" v-for="item in plan.features" :key="item">
                  <i class="el-icon-check"></i>
                  <span>{{ item }}</span>
                </div>
              </div>
              <!-- 套餐选择按钮 -->
              <el-button :type="plan.recommended ? 'primary' : 'default'" size="large" class="plan-button">
                {{ plan.buttonText }}
              </el-button>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA区域 -->
      <section class="cta-section">
        <div class="section-container">
          <h2 class="cta-title">立即启用视频解析能力</h2>
          <p class="cta-subtitle">快速接入接口，实时拿到水印状态与互动数据</p>
          <el-button type="primary" size="large" @click="showRegisterDialog" class="cta-main-button">
            免费注册试用
          </el-button>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-section">
          <div class="footer-logo">
            <img src="@/assets/logo.png" alt="视频回调信息解析" class="footer-logo-img" />
            <span class="footer-logo-text">视频回调信息解析</span>
          </div>
          <p class="footer-description">
            专业的视频回调信息解析平台，提供高效、稳定、安全的服务
          </p>
        </div>
        <div class="footer-section">
          <h4 class="footer-title">产品</h4>
          <a href="#" class="footer-link">视频解析</a>
          <a href="#" class="footer-link">数据监控</a>
          <a href="#" class="footer-link">API接口</a>
          <a href="#" class="footer-link">定价</a>
        </div>
        <div class="footer-section">
          <h4 class="footer-title">资源</h4>
          <a href="#" class="footer-link">文档中心</a>
          <a href="#" class="footer-link">API文档</a>
          <a href="#" class="footer-link">帮助中心</a>
          <a href="#" class="footer-link">博客</a>
        </div>
        <div class="footer-section">
          <h4 class="footer-title">公司</h4>
          <a href="#" class="footer-link">关于我们</a>
          <a href="#" class="footer-link">联系我们</a>
          <a href="#" class="footer-link">服务条款</a>
          <a href="#" class="footer-link">隐私政策</a>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© 2025 视频回调信息解析平台. 保留所有权利.</p>
      </div>
    </footer>

    <!-- 登录注册对话框 -->
    <el-dialog
      v-model="dialogVisible"
      title="账号登录 / 注册"
      width="520px"
      :before-close="closeDialog"
      class="custom-dialog"
    >
      <div class="dialog-content">
        <el-tabs v-model="activeTab" stretch>
          <el-tab-pane label="用户登录" name="login">
            <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef" class="login-form">
              <el-form-item prop="account">
                <el-input v-model="loginForm.account" placeholder="请输入账号" prefix-icon="User" clearable 
                  class="custom-input" />
              </el-form-item>

              <el-form-item prop="password">
                <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="Lock"
                  show-password clearable class="custom-input" />
              </el-form-item>

              <el-form-item>
                <el-checkbox v-model="rememberMe" label="记住密码" class="remember-checkbox" />
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="handleLogin" :loading="loading" class="login-button">
                  登录
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="用户注册" name="register">
            <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef" class="register-form">
              <el-form-item prop="account">
                <el-input v-model="registerForm.account" placeholder="请输入账号" prefix-icon="User" clearable 
                  class="custom-input" />
              </el-form-item>

              <el-form-item prop="password">
                <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" prefix-icon="Lock"
                  show-password clearable class="custom-input" />
              </el-form-item>

              <el-form-item prop="confirmPassword">
                <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入密码" prefix-icon="Lock"
                  show-password clearable class="custom-input" />
              </el-form-item>

              <el-form-item prop="phone">
                <el-input v-model="registerForm.phone" placeholder="请输入手机号" prefix-icon="Iphone" clearable 
                  class="custom-input" />
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="handleRegister" :loading="loading" class="register-button">
                  注册
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      dialogType: 'login',
      activeTab: 'login',
      loading: false,
      rememberMe: false,
      loginForm: {
        account: '',
        password: ''
      },
      registerForm: {
        account: '',
        password: '',
        confirmPassword: '',
        phone: ''
      },
      loginRules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      registerRules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ]
      },
      stats: [
        { value: '99.9%', label: '解析准确率' },
        { value: '<120ms', label: '水印识别延迟' },
        { value: '20K+', label: '日解析视频' },
        { value: '点赞/分享/关注', label: '互动数据覆盖' }
      ],
      features: [
        {
          icon: 'VideoCamera',
          title: '视频结构解析',
          description: '解析视频基础信息、封面与时长，形成结构化数据资产',
          color: '#60A5FA'
        },
        {
          icon: 'Picture',
          title: '水印智能识别',
          description: '自动判断是否带水印，支持多平台水印样式检测',
          color: '#38BDF8'
        },
        {
          icon: 'DataAnalysis',
          title: '互动数据采集',
          description: '同步获取点赞、分享、关注等关键指标，支持实时更新',
          color: '#93C5FD'
        },
        {
          icon: 'Timer',
          title: '低延迟处理',
          description: '高并发调度，秒级完成视频解析与数据入库',
          color: '#3B82F6'
        },
        {
          icon: 'Connection',
          title: '统一API接入',
          description: '标准化接口输出，快速集成业务系统与数据看板',
          color: '#7DD3FC'
        },
        {
          icon: 'Monitor',
          title: '可视化监控',
          description: '全链路监控解析任务，异常自动告警与重试',
          color: '#60A5FA'
        }
      ],
      pricingPlans: [
        {
          name: '普通用户',
          price: '0.003',
          description: '按次计费，随用随付',
          features: [
            '按调用次数计费',
            '¥0.003 / 次',
            '基础视频解析 + 水印识别',
            '按需获取互动数据'
          ],
          buttonText: '立即开通',
          recommended: false
        },
        {
          name: '合作商户',
          price: '免费',
          description: '合作伙伴专属权益',
          features: [
            '合作商户免费使用',
            '全量视频解析能力',
            '优先技术支持',
            '数据接口额度保障'
          ],
          buttonText: '申请合作',
          recommended: true
        },
        {
          name: '黑钻客户',
          price: '999元',
          description: '原价终身免费使用',
          features: [
            '终身免费使用',
            '全功能解锁',
            '专属客户经理',
            '企业级保障服务'
          ],
          buttonText: '升级黑钻',
          recommended: false
        }
      ]
    };
  },
  methods: {
    showLoginDialog() {
      this.dialogType = 'login';
      this.dialogVisible = true;
      this.activeTab = 'login';
    },
    showRegisterDialog() {
      this.dialogType = 'register';
      this.dialogVisible = true;
      this.activeTab = 'register';
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.loginFormRef?.resetFields();
      this.$refs.registerFormRef?.resetFields();
    },
    scrollToFeatures() {
      const featuresSection = this.$refs.featuresSection;
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async handleLogin() {
      this.$refs.loginFormRef.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await this.$axios.post(`api/user/login`, {
              account: this.loginForm.account,
              password: this.loginForm.password
            });
            console.log(response);
            if (response.code == 0) {
              this.$message.error(response.msg || '登录失败');
              return;
            }
            const token = response.data.userinfo.token;
            const userInfo = response.data.userinfo;
            console.log('登录成功，token:', token);
            this.$store.dispatch('setToken', token);
            this.$store.dispatch('setUserInfo', userInfo);

            if (this.rememberMe) {
              localStorage.setItem('savedaccount', this.loginForm.account);
              localStorage.setItem('savedPassword', this.loginForm.password);
            } else {
              localStorage.removeItem('savedaccount');
              localStorage.removeItem('savedPassword');
            }
            this.$message.success(response.msg || '登录成功');
            this.dialogVisible = false;
            this.$router.push('/dashboard');
          } catch (error) {
            console.error('登录失败:', error);
            this.$message.error(error?.data?.msg || '登录失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async handleRegister() {
      this.$refs.registerFormRef.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await this.$axios.post(`api/user/register`, {
              username: this.registerForm.account,
              password: this.registerForm.password,
              phone: this.registerForm.phone
            });
            if (response.code == 0) {
              this.$message.error(response.msg || '注册失败');
              return;
            }
            this.$message.success('注册成功');
            this.dialogVisible = false;
            this.loginForm.account = this.registerForm.account;
            this.loginForm.password = this.registerForm.password;
            this.$refs.registerFormRef.resetFields();
          } catch (error) {
            this.$message.error(error.response?.data?.msg || '注册失败');
          } finally {
            this.loading = false;
          }
        }
      });
    },
    loadSavedCredentials() {
      const account = localStorage.getItem('savedaccount');
      const password = localStorage.getItem('savedPassword');
      if (account && password) {
        this.loginForm.account = account;
        this.loginForm.password = password;
        this.rememberMe = true;
      }
    }
  },
  mounted() {
    this.loadSavedCredentials();
    if (this.$store.getters.token) {
      this.$router.push('/dashboard');
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Rajdhani:wght@500;600;700&display=swap');

.homepage-container {
  min-height: 100vh;
  background:
    radial-gradient(circle at 12% 18%, rgba(96, 165, 250, 0.22), transparent 45%),
    radial-gradient(circle at 88% 12%, rgba(56, 189, 248, 0.2), transparent 40%),
    linear-gradient(180deg, #ffffff 0%, #eef7ff 45%, #e2f1ff 100%);
  color: #0f172a;
  font-family: 'Space Grotesk', 'Rajdhani', sans-serif;
}

/* 导航栏样式 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(191, 219, 254, 0.8);
  z-index: 1000;
  padding: 0 20px;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 40px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-img {
  width: 32px;
  height: 32px;
  filter: drop-shadow(0 0 12px rgba(59, 130, 246, 0.35));
}

.logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.5px;
}

.nav-menu {
  display: flex;
  gap: 30px;
}

.nav-item {
  color: #334155;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s;
}

.nav-item:hover {
  color: #2563eb;
  background-color: rgba(59, 130, 246, 0.12);
}

.nav-item.active {
  color: #2563eb;
  background-color: rgba(59, 130, 246, 0.18);
  box-shadow: 0 0 18px rgba(59, 130, 246, 0.2);
}

.nav-right {
  display: flex;
  gap: 12px;
}

.login-btn {
  padding: 8px 20px;
  border: 1px solid rgba(96, 165, 250, 0.7) !important;
  background: rgba(255, 255, 255, 0.7) !important;
  color: #1e3a8a !important;
}

.register-btn {
  padding: 8px 20px;
  border: 1px solid rgba(147, 197, 253, 0.8) !important;
  background: rgba(191, 219, 254, 0.35) !important;
  color: #1d4ed8 !important;
}

/* 主内容区域 */
.main-content {
  padding-top: 64px;
}

/* 英雄区域 */
.hero-section {
  padding: 100px 20px 90px;
  background: transparent;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.2), transparent 55%);
  opacity: 0.9;
  pointer-events: none;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.hero-content {
  max-width: 500px;
}

.hero-title {
  font-size: 52px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 20px;
  line-height: 1.1;
  letter-spacing: 0.5px;
}

.hero-subtitle {
  font-size: 18px;
  color: #475569;
  margin-bottom: 30px;
  line-height: 1.7;
}

.hero-buttons {
  display: flex;
  gap: 16px;
}

.cta-button {
  padding: 12px 32px;
  background: linear-gradient(135deg, #60a5fa, #38bdf8) !important;
  border: none !important;
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.25);
}

.secondary-button {
  padding: 12px 32px;
  border: 1px solid rgba(96, 165, 250, 0.5) !important;
  background: rgba(255, 255, 255, 0.7) !important;
  color: #1e3a8a !important;
}

/* 仪表板预览 */
.dashboard-preview {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(148, 163, 184, 0.35);
  border: 1px solid rgba(191, 219, 254, 0.8);
  overflow: hidden;
}

.dashboard-header {
  background: rgba(248, 250, 252, 0.9);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(191, 219, 254, 0.8);
}

.dashboard-dots {
  display: flex;
  gap: 6px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.dot.red {
  background-color: #ff5f56;
}

.dot.yellow {
  background-color: #ffbd2e;
}

.dot.green {
  background-color: #27ca3f;
}

.dashboard-title {
  color: #475569;
  font-size: 14px;
}

.dashboard-content {
  padding: 20px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: start;
}

.json-preview {
  background: rgba(239, 246, 255, 0.9);
  border-radius: 12px;
  border: 1px solid rgba(191, 219, 254, 0.8);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: auto;
}

.json-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e3a8a;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.json-block {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #1e293b;
  background: #ffffff;
  border-radius: 10px;
  padding: 12px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  max-height: 280px;
  overflow: auto;
  font-family: 'Space Grotesk', 'Rajdhani', monospace;
}

.chart-container {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  height: 120px;
  padding: 10px;
  background: rgba(239, 246, 255, 0.8);
  border-radius: 10px;
}

.chart-line {
  flex: 1;
  background: linear-gradient(to top, #60a5fa, #38bdf8);
  border-radius: 4px 4px 0 0;
  min-height: 20px;
}

.stats-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.stat-item {
  background: rgba(255, 255, 255, 0.9);
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(191, 219, 254, 0.8);
  text-align: center;
}

.stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #64748b;
}

/* 特性区域 */
.features-section {
  padding: 90px 20px;
  background: rgba(255, 255, 255, 0.75);
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 18px;
  color: #475569;
  text-align: center;
  margin-bottom: 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.feature-card {
  background: rgba(255, 255, 255, 0.92);
  padding: 32px;
  border-radius: 16px;
  border: 1px solid rgba(191, 219, 254, 0.8);
  transition: all 0.3s;
  text-align: center;
  box-shadow: 0 18px 40px rgba(148, 163, 184, 0.25);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  inset: -30% -10% auto auto;
  width: 140px;
  height: 140px;
  background:
    radial-gradient(circle, rgba(96, 165, 250, 0.18), transparent 70%),
    radial-gradient(circle, rgba(56, 189, 248, 0.16), transparent 60%);
  transform: rotate(12deg);
  pointer-events: none;
}

.feature-card::after {
  content: '';
  position: absolute;
  inset: auto auto -45% -25%;
  width: 180px;
  height: 180px;
  background:
    linear-gradient(135deg, rgba(226, 232, 240, 0.7), transparent),
    repeating-linear-gradient(90deg, rgba(191, 219, 254, 0.45), rgba(191, 219, 254, 0.45) 1px, transparent 1px, transparent 8px);
  opacity: 0.6;
  border-radius: 40% 60% 60% 40%;
  pointer-events: none;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 50px rgba(59, 130, 246, 0.2);
  border-color: rgba(96, 165, 250, 0.8);
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 24px;
}

.feature-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
}

.feature-description {
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
}

/* 定价区域 */
.pricing-section {
  padding: 90px 20px;
  background: transparent;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.pricing-card {
  background: rgba(255, 255, 255, 0.92);
  border-radius: 18px;
  border: 1px solid rgba(191, 219, 254, 0.8);
  padding: 32px;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  box-shadow: 0 18px 40px rgba(148, 163, 184, 0.25);
}

.pricing-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 50px rgba(59, 130, 246, 0.2);
}

.pricing-card:nth-child(2) {
  border-color: rgba(96, 165, 250, 0.9);
  transform: scale(1.05);
  box-shadow: 0 30px 60px rgba(59, 130, 246, 0.2);
}

.pricing-card:nth-child(2):hover {
  transform: scale(1.05) translateY(-5px);
}

.pricing-header {
  text-align: center;
  margin-bottom: 30px;
}

.plan-name {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
}

.plan-price {
  margin-bottom: 12px;
}

.price {
  font-size: 48px;
  font-weight: 700;
  color: #0f172a;
}

.period {
  font-size: 16px;
  color: #64748b;
}

.plan-description {
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
}

.plan-features {
  flex: 1;
  margin-bottom: 30px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  color: #475569;
}

.feature-item i {
  color: #67C23A;
}

.plan-button {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, rgba(96, 165, 250, 0.95), rgba(56, 189, 248, 0.95)) !important;
  border: none !important;
  color: #0f172a !important;
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.2);
}

/* CTA区域 */
.cta-section {
  padding: 90px 20px;
  background: radial-gradient(circle at 20% 20%, rgba(96, 165, 250, 0.3), transparent 50%),
    linear-gradient(135deg, #f8fbff 0%, #e6f3ff 100%);
  text-align: center;
  border-top: 1px solid rgba(191, 219, 254, 0.8);
}

.cta-title {
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
}

.cta-subtitle {
  font-size: 18px;
  color: #475569;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-main-button {
  padding: 12px 40px;
  background: linear-gradient(135deg, #60a5fa 0%, #38bdf8 100%);
  color: #0f172a;
  border: none;
  box-shadow: 0 14px 36px rgba(59, 130, 246, 0.2);
}

.cta-main-button:hover {
  filter: brightness(1.05);
}

/* 页脚 */
.footer {
  background: #eff6ff;
  color: #0f172a;
  padding: 60px 20px 20px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.footer-logo-img {
  width: 32px;
  height: 32px;
}

.footer-logo-text {
  font-size: 18px;
  font-weight: bold;
}

.footer-description {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
}

.footer-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}

.footer-link {
  color: #64748b;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: white;
}

.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  border-top: 1px solid rgba(191, 219, 254, 0.8);
  text-align: center;
  color: #64748b;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .hero-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .features-grid,
  .pricing-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .footer-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .nav-left {
    gap: 20px;
  }
  
  .nav-menu {
    display: none;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .features-grid,
  .pricing-grid {
    grid-template-columns: 1fr;
  }
  
  .footer-container {
    grid-template-columns: 1fr;
  }
  
  .dashboard-content {
    grid-template-columns: 1fr;
  }
}

/* 对话框样式 */
.custom-dialog {
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(100, 116, 139, 0.18) !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  background: #ffffff;
  position: relative;
}

.custom-dialog .el-dialog__header {
  background: #ffffff;
  margin: 0;
  padding: 24px 32px 8px;
  border-bottom: none;
}

.custom-dialog .el-dialog__title {
  color: #0f172a;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}

.custom-dialog .el-dialog__headerbtn {
  top: 28px;
  right: 32px;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #94a3b8;
  font-size: 20px;
  transition: transform 0.3s ease;
}

.custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  transform: scale(1.2);
}

.custom-dialog .el-dialog__body {
  padding: 18px 32px 36px;
  background: #ffffff;
  position: relative;
  overflow: hidden;
}

.custom-dialog .el-dialog__body::before {
  content: none;
}

.custom-dialog .el-dialog__body::after {
  content: none;
}

.dialog-content {
  padding: 0;
  position: relative;
  z-index: 1;
}

.login-form,
.register-form {
  background: #ffffff;
  backdrop-filter: none;
  padding: 24px 24px 10px;
  border-radius: 18px;
  box-shadow: none;
  border: none;
  position: relative;
  overflow: hidden;
}

.login-form::before,
.register-form::before {
  content: none;
}

@keyframes gradientFlow {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.custom-input {
  border-radius: 10px !important;
  border: 1px solid rgba(226, 232, 240, 0.9);
  transition: all 0.2s ease;
}

.custom-input:hover {
  border-color: rgba(59, 130, 246, 0.6);
  box-shadow: none;
  transform: none;
}

.custom-input:focus-within {
  border-color: rgba(59, 130, 246, 0.8);
  box-shadow: 0 0 0 3px rgba(191, 219, 254, 0.7);
  transform: none;
}

.custom-input .el-input__wrapper {
  border-radius: 10px;
  background: #f8fafc;
  padding: 10px 14px;
  box-shadow: none;
}

.custom-input .el-input__inner {
  color: #0f172a;
  font-size: 15px;
  font-weight: 500;
}

.custom-input .el-input__prefix {
  color: #94a3b8;
  margin-right: 10px;
}

.custom-input .el-input__suffix {
  color: #94a3b8;
}

.remember-checkbox {
  margin-bottom: 18px;
}

.remember-checkbox .el-checkbox__label {
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
}

.remember-checkbox .el-checkbox__inner {
  border-radius: 6px;
  border-color: rgba(226, 232, 240, 0.9);
  background: #ffffff;
}

.remember-checkbox .el-checkbox__inner:hover {
  border-color: #3b82f6;
}

.login-button,
.register-button {
  width: 100%;
  height: 46px;
  border-radius: 24px !important;
  background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%) !important;
  border: none !important;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: none;
  transition: all 0.2s ease !important;
  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.25);
  position: relative;
  overflow: hidden;
}

.login-button::before,
.register-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.7s ease;
}

.login-button:hover,
.register-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 26px rgba(37, 99, 235, 0.28);
}

.login-button:hover::before,
.register-button:hover::before {
  left: 100%;
}

.login-button:active,
.register-button:active {
  transform: translateY(0);
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
}

.login-button:disabled,
.register-button:disabled {
  opacity: 0.7;
  transform: none !important;
  box-shadow: none !important;
}

/* 标签页样式 */
.el-tabs__nav-wrap {
  padding: 0 20px;
}

.el-tabs__nav-wrap::after {
  background-color: rgba(226, 232, 240, 0.8);
  height: 1px;
}

.el-tabs__active-bar {
  background-color: #2563eb;
  height: 2px;
  border-radius: 999px;
}

.el-tabs__item {
  color: #94a3b8;
  font-weight: 600;
  font-size: 15px;
  padding: 0 18px;
  transition: all 0.2s ease;
}

.el-tabs__item:hover {
  color: #2563eb;
  transform: none;
}

.el-tabs__item.is-active {
  color: #0f172a;
  text-shadow: none;
}

/* 表单项间距 */
.el-form-item {
  margin-bottom: 24px;
}

.el-form-item:last-child {
  margin-bottom: 0;
}

.el-form-item__label {
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  display: block;
}

/* 弹窗动画 */
.el-dialog {
  animation: dialogFadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes dialogFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-30px) scale(0.9) rotateX(10deg);
  }
  50% {
    opacity: 0.8;
    transform: translateY(10px) scale(1.02) rotateX(-2deg);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1) rotateX(0);
  }
}

/* 弹窗关闭动画 */
.el-dialog.is-closing {
  animation: dialogFadeOut 0.3s ease forwards;
}

@keyframes dialogFadeOut {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
}

/* 按钮加载动画 */
.el-button--primary.is-loading {
  position: relative;
  overflow: hidden;
}

.el-button--primary.is-loading::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(
    transparent,
    rgba(64, 158, 255, 0.8),
    transparent 30%
  );
  animation: buttonSpin 1.5s linear infinite;
}

@keyframes buttonSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.el-button--primary.is-loading::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
  border-radius: 12px;
  z-index: 1;
}

.el-button--primary.is-loading .el-button__text {
  position: relative;
  z-index: 2;
}

/* 输入框图标动画 */
.custom-input .el-input__prefix i {
  transition: transform 0.3s ease, color 0.3s ease;
}

.custom-input:hover .el-input__prefix i {
  transform: scale(1.1);
  color: #66B1FF;
}

.custom-input:focus-within .el-input__prefix i {
  transform: scale(1.2);
  color: #409EFF;
}

/* 表单整体动画 */
.login-form,
.register-form {
  animation: formSlideIn 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.1s both;
}

@keyframes formSlideIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
